// extracted by mini-css-extract-plugin
module.exports = {"alert-title":"style_alert-title__DO2QW"};